<style scoped>
  .search-div {
      display:flex;
      flex-wrap:wrap
  }
  .dateItem{
      margin-right: 20px;
  }
  .dateLabel{
       margin-right: 10px;
  }

</style>
<template>
    <div class="marginCon">
        <Card>
            <!-- 搜索 -->
            <div class="search-div">
              
                <div  class="dateItem">
                    <span class="dateLabel">{{$t('account.cost.startMonth')}}</span>
                    <DatePicker type="month" :placeholder="$t('selectPlaceholder')" @on-change='selectT($event,1)' style="width: 200px"></DatePicker>
                </div>
                <div class="dateItem">
                    <span class="dateLabel">{{$t('account.cost.endMonth')}}</span>
                    <DatePicker type="month" :placeholder="$t('selectPlaceholder')" @on-change='selectT($event,2)' style="width: 200px"></DatePicker>
                </div>
    
                 <Button type="info" @click="searchItem"  icon="ios-search" style="width:96px;border-radius: 6px;">{{$t('search')}}</Button>
            </div>
            <div v-if="offModel">
                <div>
                   <Table max-height='420' style="width: 100%;margin-top: 30px;" :columns="titleName" :data="tableList.tableData"  ref="selection" @on-sort-change="sortCustom($event,'0')" :loading='loading1'></Table>
                </div>
    
                <div>
                   <Table style="width: 100%;margin-top: 30px;" :columns="titleName1" :data="tableList1.tableData"  ref="selection1" @on-sort-change="sortCustom($event,'1')" :loading='loading'></Table>
                   <Page @on-change="changePage" @on-page-size-change="changeSize" :total="page1.total" show-sizer :show-total="true" :current="page1.current" :page-size="page1.pageSize" :page-size-opts="[10,15,20]" placement="top" class="pages"/>
                </div>
            </div>
        </Card>
    </div>
</template>

<script>

import common from '@/common/common.js';
import moment from 'moment';
import { mapState } from 'vuex'

    export default {
        name: "firmwareVersion",
        components: {
            
        },
        data(){
            return{
                loading: true,
                loading1: true,
                offModel: true,
                page:{//分页排序
                    total:0,//总条数
                    pageSize:10,//每页条数
                    current:1,//当前页
                    key:'created_at',
                    order:'desc'
                },
                page1:{//分页排序
                    total:0,//总条数
                    pageSize:10,//每页条数
                    current:1,//当前页
                    key:'created_at',
                    order:'desc'
                },
                searchObj:{
                    beginInterval:'',
                    endInterval:''
                },
                tableList:{
                    tableData:[]
                },
                tableList1:{
                    tableData:[]
                },
               
            }
        },
        computed:{
           ...mapState(['local','selectId','uInfo']),
            roleType(){
	        	let res = '2'
	        	if(this.uInfo && this.uInfo.roleType){
	        	 res = this.uInfo.roleType
	        	}
	        	return res
	        },
            titleName(){
                return [
                    {
                        title:this.$t('accountSMScost.titleName.Month'),
                        'title-zh-CN':'月份',
                        'title-en-US':'Month',
                        key: 'Month',
                        minWidth: 130,
                        sortable: true,
                        tree: true,
                        render:(h,params)=>{
                            let stext = moment(params.row.startTime*1).format('YYYY-MM')
                            return h('div',stext || '')
                        }
                    },
                    {
                        title:this.$t('accountSMScost.titleName.smsNumber'),
                        'title-zh-CN':'短信数量',
                        'title-en-US':'SMS count',
                        key: 'smsNumber',
                        minWidth: 130
                    },
                    {
                        title:this.$t('accountSMScost.titleName.totalAmount'),
                        'title-zh-CN':'总费用',
                        'title-en-US':'Total amount',
                        key: 'totalAmount',
                        minWidth: 130
                    }
                ]
            },
            titleName1(){
                return [
                    {
                        title:this.$t('accountSMScost.titleName1.countryNameEn'),
                        'title-zh-CN':'国际名称',
                        'title-en-US':'International name',
                        key: 'countryNameEn',
                        minWidth: 180,
                        sortable: true
                    },
                    {
                        title:this.$t('accountSMScost.titleName1.countryName'),
                        'title-zh-CN':'中文名称',
                        'title-en-US':'Chinese name',
                        key: 'countryName',
                        minWidth: 180
                    },
                    {
                        title:this.$t('accountSMScost.titleName1.simpleCountryName'),
                        'title-zh-CN':'国家代码',
                        'title-en-US':'Country code',
                        key: 'simpleCountryName',
                        minWidth: 130
                    },
                    {
                        title:this.$t('accountSMScost.titleName1.internationalCode'),
                        'title-zh-CN':'区号',
                        'title-en-US':'Area code',
                        key: 'internationalCode',
                        minWidth: 130
                    },
                    {
                        title:this.$t('accountSMScost.titleName1.locatedContinent'),
                        'title-zh-CN':'大洲',
                        'title-en-US':'Continent',
                        key: 'locatedContinent',
                        minWidth: 130
                    },
                    {
                        title:this.$t('accountSMScost.titleName1.referencePrice'),
                        'title-zh-CN':'参考价格',
                        'title-en-US':'Reference price',
                        key: 'referencePrice',
                        minWidth: 150
                    },
                    {
                        title:this.$t('accountSMScost.titleName1.marketPrice'),
                        'title-zh-CN':'市场价格',
                        'title-en-US':'Market price',
                        key: 'marketPrice',
                        minWidth: 150,
                        render: (h, params) => {
                          //使用抽离出的getRender函数，来执行后续的render行为
                           if(this.roleType==1){
                              return h('Input', this.getRender(h, params, 'marketPrice','input')); 
                           }else{
                               return h('div', params.row.marketPrice); 
                           }
                        }
                    },
                   {
			    	    title:this.$t('accountSMScost.titleName1.Operation'),
                        'title-zh-CN':'操作',
                        'title-en-US':'Operation',
			    	    minWidth:120,
                        key: "Operation",
                        // fixed:'right',
			    	    render: (h, params) => {
                            let that = this
                            return h('i-Switch', {
			    			    props: {
			    			    	size: 'large',
			    			    	value: params.row.openSmsStatus
			    			    },
                                on:{
                                    'on-change':(value)=>{
                                        this.changeSwitch(value,params.row)
                                        // console.log(value)
                                    }
                                }
			    		    })
			    	    }
			    	},
                ]
            } ,
        },
        created (){

            this.getData()
            this.getDataCountry()
        },

        methods: {
            getRender(h, params, key,types){//修改某个国家短信的市场价格
                return{
                    props: {
                        value: params.row[key]
                    },
                    class:"input-table",  // 定义一个类来控制单元格的样式
                    style:{
                        width:'100%!important'
                    },
                    on:{
                        'on-blur':(event) => {
                            if(types == 'input'){
                                let resVal = (event.currentTarget.value).trim()
                                let reg = /^[1-9]\d*$|^[1-9]\d*\.\d\d?$|^0\.\d\d?$/
                                if(resVal == params.row[key] || !reg.test(resVal)){
                                    event.currentTarget.value = params.row[key];
                                    return
                                }
                          		this.tableList1.tableData[params.index][params.column.key] = resVal; 
                              
                                this.axios.post(this.config.urlArray.marketPriceSet, {'marketPrice':resVal,id:params.row.id,dealerId:this.selectId}).then((result) => {
                                    common.ajaxMsg(result.data,true);
                                    this.getData()
                                    
                                }).catch((err) => {
                                   
                                    this.disabled = false;
                                });
                           }
                            
                        }
                    }
                }
            },
            selectT(val,type){
                switch (type*1) {
                    case 1 :
                        this.searchObj.beginInterval = val.replace(/-/, "")
                        break
                    case 2 :
                        this.searchObj.endInterval = val.replace(/-/, "")
                        break
                }
            },
            changeSwitch(val,item){//修改switch
                let getData = {
                    openSmsStatus:val,
                    id:item.id
                }
                this.axios.post(this.config.urlArray.openSmsStatus,getData).then((result) => {
                    common.ajaxMsg(result.data,true,()=>{
                    });
                }).catch((err) => {
                    // common.msg('error','获取失败',()=>{})
                });
            },
            searchItem(){
                this.loading1 = true
                this.page.current = 1
                this.page.pageSize = 10
                this.getDataCountry()
            },
            getDataCountry(){ //获取数据
                let getData = {
                    params:{
                        page:this.page.current,
                        limit:this.page.pageSize,
                        // sort:this.page.key,
                        // asc:this.page.order,
                        dealerId:this.selectId,
                        ...this.searchObj
                    }
                }
                this.axios.post(this.config.urlArray.smsstatisticList,getData.params).then((result) => {
                    common.ajaxMsg(result.data,false,()=>{

                        let resData = result.data.data
                        //处理数组
                        if(resData){
                            this.tableList.tableData = resData  //渲染数据
                            this.loading1 = false
                        }
                    });
                }).catch((err) => {
                    console.log(err)
                });
            },
            getData(){
                 let getData = {
                    params:{
                        page:this.page1.current,
                        limit:this.page1.pageSize,
                        sort:this.page1.key,
                        asc:this.page1.order,
                        dealerId:this.selectId,
                        ...this.searchObj
                    }
                }
                this.axios.post(this.config.urlArray.smsesList,getData.params).then((result) => {
                    common.ajaxMsg(result.data,false,()=>{
                        let resData = result.data.data.smsList
                        //处理数组
                        if(resData){
                            this.tableList1.tableData = resData  //渲染数据
                            this.page1.total = result.data.data.meta.count
                            this.loading = false
                        }
                    });

                }).catch((err) => {
             
                    // common.msg('error','获取失败',()=>{})
                });
            },
            sortCustom (data) {//自定义排序
                this.page1.key = data.key
                this.page1.order = data.order
                this.getData()
            },
            changePage (nowpage) {//切换分页
                this.page1.current = nowpage
                this.getData()
            },
            changeSize (nowSize) {//切换每页显示条数
                this.page1.pageSize = nowSize
                this.page1.current = 1
                this.getData()
            }
        }
    }
</script>
<style lang="less" scoped>
/deep/ .input-table{
    .ivu-input{
        border: 1px solid #fff;
    }
}
</style>


